import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

const DeleteEventModal = ({ onConfirm, onHide, show }) => (
  <Modal onHide={onHide} show={show}>
    <Modal.Header>
      <Modal.Title>
        <FontAwesome name="trash-o" /> Delete Calendar Event
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to delete this calendar event?
      This action cannot be undone.
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onHide}>Close</Button>
      <Button bsStyle="danger" onClick={onConfirm}>Delete</Button>
    </Modal.Footer>
  </Modal>
);

export default DeleteEventModal;
